import { loadScript, checkWeappByUserAgent } from '../../utils/common';
export default {
    mounted() {
        const wxurl = '//res.wx.qq.com/open/js/jweixin-1.0.0.js';
        loadScript(wxurl, 'body');
    },
    methods: {
        judgeFrom() {
            const ua = window.navigator.userAgent;
            console.log(ua, 'ua');
            // 百度小程序
            // eslint-disable-next-line unicorn/prefer-starts-ends-with
            const isSwanMiniProgram = /swan\//.test(ua) || /^webswan-/.test(window.name);
            // 快应用
            const isQuickApp = /hap/.test(ua);
            // 阿里
            const isAliMiniProgram = ua.includes('AlipayClient');
            // 微信浏览器
            const ismicromessenger = checkWeappByUserAgent(ua);
            // 微信小程序
            const isWxMiniProgram = window.__wxjs_environment === 'miniprogram';
            console.log(ismicromessenger, '是否处于微信浏览器');
            console.log(isWxMiniProgram, '是否处于微信小程序');
            // 小程序 app m pc
            // msale.58.com m.anjuke.com m.58.com
            if (isQuickApp || isSwanMiniProgram || isAliMiniProgram || isWxMiniProgram) {
                return 'wapp'; // 小程序
            }
            if (location.origin.includes('api') || location.origin.includes('appsale')) {
                return 'app';
            }
            if (
                location.origin.includes('m.anjuke.') ||
                location.origin.includes('m.58.') ||
                location.origin.includes('msale.58.')
            ) {
                return 'tw';
            }
            return 'pc';
        }
    }
};
